import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';

import {DictService} from '../core/ecv-http-services/services/dict.service';
import {DialogService} from '../dialog/dialog.service';
import {DictModel} from '../dictionary/dict.model';
import {CustomValidators} from '../core/validator/custom-validators';
import {BaseFillDataFormComponent} from '../widgets/form-section/base-fill-data-form-component';
import {EducationMode} from './education-mode.enum';
import {DictEnum} from '../enums/dict.enum';


@Component({
  selector: 'app-education-item',
  templateUrl: './education-item.component.html'
})
export class EducationItemComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  DictEnum = DictEnum;
  educationForm: FormGroup;
  dateForm: FormGroup;
  studyModes: EducationMode[];
  activeModeIndex: number;
  modalEmitter = new EventEmitter();

  constructor(private dictService: DictService, private dialogService: DialogService) {
    super();
  }

  ngOnInit(): void {
    this.initializeStudyModes();
    this.createForm();
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('educationForm' + this.formIndex);
  }

  private createForm() {
    this.dateForm = new FormGroup({
      'studyFrom': new FormControl('', CustomValidators.validateDateFormats),
      'studyTo': new FormControl('', CustomValidators.validateDateFormats),
    }, CustomValidators.validateDates('studyFrom', 'studyTo'));
    this.educationForm = new FormGroup({
      'universityName': new FormControl('', CustomValidators.notEmpty),
      'universityName-id': new FormControl('', CustomValidators.validateCorrectDict),
      'universitySchoolDegree': new FormControl(''),
      'universitySchoolDegree-id': new FormControl('', CustomValidators.validateCorrectDict),
      'universityFaculty': new FormControl(''),
      'universityFaculty-id': new FormControl('', CustomValidators.validateCorrectDict),
      'universityDirection': new FormControl(''),
      'universityDirection-id': new FormControl('', CustomValidators.validateCorrectDict),
      'universitySpeciality': new FormControl(''),
      'universitySpeciality-id': new FormControl('', CustomValidators.validateCorrectDict),
      'date': this.dateForm
    });
    this.parentForm.addControl('educationForm' + this.formIndex, this.educationForm);
  }

  onChooseStudyMode(index) {
    if (this.activeModeIndex === index && this.data.educationMode === index) {
      this.activeModeIndex = null;
      this.data.educationMode = null;
    } else {
      this.activeModeIndex = index;
      this.data.educationMode = index;
    }
  }

  private initializeStudyModes() {
    this.studyModes = [];
    for (const n in EducationMode) {
      if (typeof EducationMode[n] === 'number') {
        this.studyModes.push(EducationMode[EducationMode[n]]);
      }
    }
    this.activeModeIndex = this.getActiveStudyModeIndex();
  }

  private getActiveStudyModeIndex() {
    return this.data.educationMode;
  }

  openModal(title: string, dictType: number, control: AbstractControl, maxLength: number, property: string) {
    this.dialogService.open(title, dictType, control, maxLength, this.data, property, this.modalEmitter);
    this.modalEmitter.subscribe((element) => {
     switch (property) {
       case 'schoolDictId':
         this.educationForm.controls['universityName-id'].setValue(element.id);
         break;
       case 'titleDictId':
         this.educationForm.controls['universitySchoolDegree-id'].setValue(element.id);
         break;
       case 'facultyDictId':
         this.educationForm.controls['universityFaculty-id'].setValue(element.id);
         break;
       case 'directionDictId':
         this.educationForm.controls['universityDirection-id'].setValue(element.id);
         break;
       case 'specializationDictId':
         this.educationForm.controls['universitySpeciality-id'].setValue(element.id);
         break;
     }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/education/education-item.component.ts